// extracted by mini-css-extract-plugin
export default {"verticalFiller":"issuers-tab_verticalFiller__rJt+J"};